import { Td, Tr } from "@chakra-ui/react";
import { convertISOToLocalDate } from "../../../../utils/date.utils";

function HistoryListItem(props) {
  const { history } = props;
  const { userId, createdAt, status, terminatedAt, slug } = history;

  return (
    <>
      <Tr py="14px" key={history._id}>
        <Td
          pl="15px"
          pr="20px"
          py="14px"
          color="rgba(134, 139, 148, 1)"
          fontSize={{
            base: "fs.14",
            md: "fs.14",
            lg: "fs.16",
            xl: "fs.16",
          }}
          fontWeight="fw.500"
          width="360px"
        >
          {userId.name}
        </Td>
        <Td
          pl="15px"
          pr="20px"
          py="14px"
          color="rgba(134, 139, 148, 1)"
          fontSize={{
            base: "fs.14",
            md: "fs.14",
            lg: "fs.16",
            xl: "fs.16",
          }}
          fontWeight="fw.500"
          width="360px"
        >
          {status}
        </Td>
        <Td
          pl="15px"
          pr="20px"
          py="14px"
          color="rgba(134, 139, 148, 1)"
          fontSize={{
            base: "fs.14",
            md: "fs.14",
            lg: "fs.16",
            xl: "fs.16",
          }}
          fontWeight="fw.500"
          width="360px"
        >
          {
            slug === "amazon" ? (
              <span>Amazon Linux</span>
            ) : (
              <span style={{ textTransform: "capitalize" }}>{slug}</span>
            )
          }
        </Td>
        <Td
          pl="15px"
          pr="20px"
          py="14px"
          color="rgba(134, 139, 148, 1)"
          fontSize={{
            base: "fs.14",
            md: "fs.14",
            lg: "fs.16",
            xl: "fs.16",
          }}
          fontWeight="fw.500"
          width="360px"
        >
          {convertISOToLocalDate(createdAt)}
        </Td>

        <Td
          pl="15px"
          pr="20px"
          py="14px"
          color="rgba(134, 139, 148, 1)"
          fontSize={{
            base: "fs.14",
            md: "fs.14",
            lg: "fs.16",
            xl: "fs.16",
          }}
          fontWeight="fw.500"
          width="360px"
        >
          {convertISOToLocalDate(terminatedAt)}
        </Td>
      </Tr>
    </>
  );
}

export default HistoryListItem;
